import { Button } from '@systemeio/components'
import { DotsHorizontalIcon } from '@systemeio/icons'
import { CurrencyEnum, LocaleEnum } from '@systemeio/types'
import { centsToUnits, units } from '@systemeio/util'
import { AffiliateSumType } from 'modules/affiliate-program/affiliate/types/affiliate-interface'
import React from 'react'
import { Popover } from 'shared/components'
import { TLocoType } from 'shared/hooks/use-loco-translation'
import { currencyFormat } from 'shared/utils/currency-format'

export const getAffiliateSum = (
  amountObj: AffiliateSumType,
  selectedCurrency?: CurrencyEnum,
  locale?: LocaleEnum,
) =>
  selectedCurrency
    ? currencyFormat(centsToUnits(amountObj[selectedCurrency]), selectedCurrency, locale)
    : currencyFormat(units(0), CurrencyEnum.EURO, locale)

export const getAffiliateTotalSum = (
  amountObj: AffiliateSumType,
  t: TLocoType,
  selectedCurrency?: CurrencyEnum,
  locale?: LocaleEnum,
) => (
  <div className={'flex items-center gap-1.5'}>
    {getAffiliateSum(amountObj, selectedCurrency, locale)}
    {Object.keys(amountObj).length > 1 && (
      <Popover
        trigger={<Button aria-label={t('global.more')} variant={'ghost-color'} size={'icon-xs'} />}
        label={
          <div className={'flex flex-col gap-1 font-bold'}>
            {(Object.keys(amountObj) as CurrencyEnum[])
              .filter(cur => cur !== selectedCurrency)
              .map(cur => (
                <span key={cur}>{getAffiliateSum(amountObj, cur, locale)}</span>
              ))}
          </div>
        }
      >
        {() => <DotsHorizontalIcon />}
      </Popover>
    )}
  </div>
)
